import type React from 'react';

import { Modal } from '~/components/ui/modal';

import { WaiverModalContent } from './waiver-modal-content';

interface WaiverPreviewModalProps {
  open: boolean;
  description: React.ReactNode;
  title?: string;
  waiverHtml: string;
  onClose?: () => void;
}

export function WaiverPreviewModal({
  open,
  title,
  description,
  waiverHtml,
  onClose,
}: WaiverPreviewModalProps) {
  return (
    <Modal
      title={title ?? 'Review Waiver'}
      open={open}
      onClose={onClose}
      dialogContentProps={{
        className: 'overflow-hidden',
      }}
    >
      {description}
      <WaiverModalContent waiverHtml={waiverHtml} />
    </Modal>
  );
}
